// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"abfcef3c","453":"be18358c"}[chunkId] + ".chunk.js";
};